import { App as AntApp } from "antd";
import { HomePage } from "../pages/home-page";
import { Route, Routes } from "react-router-dom";
import { NotFoundPage } from "@/pages/not-found";

const App: React.FC = () => {
  return (
    <AntApp className="full-width" style={{ height: "100dvh" }}>
      <Routes>
        <Route path="*" element={<NotFoundPage />} />
        <Route path="/:id" element={<HomePage />} />
      </Routes>
    </AntApp>
  );
};

export default App;
